import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { perfis } from "./global";
import { isUserTemPermissao } from "../utils";
export default function RouteWrapper({ component: Component, routePerfil, ...rest }) {
  const user = useSelector((state) => state.userReducer.user);
  if (!isUserTemPermissao(routePerfil, perfis, user.contaAcesso.authorities)) {
    return (
      <Redirect
        to={{
          pathname: "/",
          state: { prevPath: rest.path },
        }}
      />
    );
  }
  return <Route {...rest} component={Component} />;
}

RouteWrapper.defaultProps = {
  routePerfil: false,
};

RouteWrapper.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  routePerfil: PropTypes.string,
};
